import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class ProveedorUsuariosView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var proveedor_Id = rawUrl.split("Proveedores/")[1].split("/")[0];
        this.state = {
            operation: props.operation
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {id:"", proveedor_Id: proveedor_Id, nombre: "", apellidos: "", email: "", userName: "", password: "" };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            email: this.state.model.email != "",
            userName: this.state.model.userName != "",
            password: this.state.model.password != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/proveedorUsuarios/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup style={{display: 'none'} }>
                            <input type="text" />
                            <input type="password" />
                        </FormGroup>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="userName">
                                        <FormattedMessage id='UserName' />
                                    </Label>
                                    <FormattedMessage id='UserName'>
                                        {(placeholder) =>
                                            <Input
                                                id="userName"
                                                name="userName"
                                                placeholder={placeholder}
                                                type="text"
                                                autoComplete="nope"
                                                onChange={this.handleChange}
                                                value={this.state.model.userName}
                                                valid={this.getValidationValue(this.state.modelValidation.userName)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.userName)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.userName == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='UserName no disponible' />}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col></Col>
                            
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="email">
                                        <FormattedMessage id='Email' />
                                    </Label>
                                    <FormattedMessage id='Email'>
                                        {(placeholder) =>
                                            <Input
                                                id="email"
                                                name="email"
                                                placeholder="email@email.email"
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.email}
                                                valid={this.getValidationValue(this.state.modelValidation.email)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.email)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.email == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Email no valido o no disponible' />}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="password">
                                        <FormattedMessage id='Password' />
                                    </Label>
                                    <FormattedMessage id='Password'>
                                        {(placeholder) =>
                                            <Input
                                                id="password"
                                                name="password"
                                                placeholder={placeholder}
                                                type="password"
                                                autoComplete="off"
                                                onChange={this.handleChange}
                                                value={this.state.model.password}
                                                valid={this.getValidationValue(this.state.modelValidation.password)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.password)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.password == '' ? <FormattedMessage id='Este campo es requerido' /> :''}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='Nombre' />
                                    </Label>
                                    <FormattedMessage id='Nombre'>
                                        {(placeholder) =>
                                            <Input
                                                id="nombre"
                                                name="nombre"
                                                placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.nombre}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="apellidos">
                                        <FormattedMessage id='Apellidos' />
                                    </Label>
                                    <FormattedMessage id='Apellidos'>
                                        {(placeholder) =>
                                            <Input
                                                id="apellidos"
                                                name="apellidos"
                                                placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.apellidos}
                                            />
                                        }
                                    </FormattedMessage>
                                </FormGroup>
                            </Col>
                        </Row>  
                    </Form>
                </Row>
            </div>
        );
    }

}